export default __webpack_public_path__ + "static/media/windies.5a6af191.png";